import React from "react";
import { Tag } from "antd";
import moment from "moment";
import CurrencyFormatter from "../../../../components/CurrencyFormatter";

const ProductGrid = ({
  productsList,
  activeCategory,
  appConfig,
  t,
  authUser,
  is_stock_management_active,
  is_ticketing_addon_active,
  onProductClick,
}) => {
  return (
    <div className="pos-product-grid">
      {productsList.map((product) => {
        if (
          parseInt(activeCategory, 10) === product.category_id ||
          parseInt(activeCategory, 10) === 0
        ) {
          const stock = Number(product.stock) || 0;
          const lowStockValue = Number(product.low_stock) || 0;

          const isExpired =
            is_ticketing_addon_active &&
            is_stock_management_active &&
            product.expiry_date &&
            moment(product.expiry_date, "YYYY-MM-DD").isBefore(
              moment().startOf("day"),
            );

          const outOfStock =
            is_stock_management_active && product.is_stockable && stock === 0;

          const lowStock =
            is_stock_management_active &&
            product.is_stockable &&
            stock > 0 &&
            stock <= lowStockValue;

          const isProductDisabled = isExpired || outOfStock;
          const productCardClassName = `pos-product-card ${
            isProductDisabled
              ? "pos-product-card-disabled"
              : "pos-product-card-active"
          }`;

          return (
            <div className="pos-product-wrapper" key={`product-${product.id}`}>
              {(outOfStock || lowStock) && (
                <div className="pos-product-badge pos-product-badge-left">
                  {outOfStock ? (
                    <Tag color="red" className="app-m-0">
                      {t("out_of_stock")}
                    </Tag>
                  ) : (
                    <Tag color="orange" className="app-m-0">
                      {t("low_stock")}
                    </Tag>
                  )}
                </div>
              )}

              {isExpired && (
                <div className="pos-product-badge pos-product-badge-right">
                  <Tag color="red" className="app-m-0">
                    {t("expired")}
                  </Tag>
                </div>
              )}

              <div
                className={productCardClassName}
                aria-disabled={isProductDisabled}
                onClick={() => onProductClick(product)}
              >
                <div className="pos-product-thumb">
                  <img
                    alt={product.name}
                    src={
                      product.image ? product.image : "/images/image-not-found.png"
                    }
                  />
                </div>

                <div className="pos-product-body">
                  <div className="pos-product-header">
                    <h3 className="pos-product-title">
                      {appConfig.direction === "rtl"
                        ? product.name
                        : product.name_en}
                    </h3>

                    <div className="pos-product-price">
                      <CurrencyFormatter value={product.price} />
                    </div>
                  </div>

                  <div className="pos-product-meta">
                    {is_stock_management_active && product.is_stockable && (
                      <span className="pos-product-stock">
                        {t("stock")}: {stock}
                      </span>
                    )}
                    {authUser?.is_calories && product.calories_info && (
                      <span className="pos-product-calories">
                        {t("calories")}: {product.calories_info}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          );
        }

        return null;
      })}
    </div>
  );
};

export default ProductGrid;
